<template>
  <div class="sky-deploy-step-view-netwrok-info">
    <div class="computer-room-network">
      <div class="wsp-group-title">
        <div class="wsp-group-title-icon"></div>
        <div class="wsp-group-title-value">机房网络</div>
      </div>
      <div class="computer-room-network">
        <h3 style="">
          本次交付服务台数<span class="bg-red font-size-18">{{ serverIpCount }}</span
          >台，服务器IP需要<span class="bg-3bb113 font-size-18">{{ serverIpCount }}</span
          >个（其中<span class="color-38a4f5 font-size-18">{{ serverVipCount }}</span
          >个为VIP）
        </h3>
      </div>
      <div class="computer-room-network">
        <el-form ref="firstForm" :rules="rules" label-position="right" label-width="100px" style="width: 100%;">
          <el-table
            class="cal-table custom-cell-table"
            :key="serverNetWorkResourceKey"
            :data="serverNetworkList"
            stripe
            max-height="350"
            style="width: 100%;height: 250"
          >
            <el-table-column style="height: 0rem;" prop="useName" label="IP规划用途" width="135" align="center">
              <template slot-scope="scope">
                <el-input
                  :class="`${scope.row.useName ? '' : 'input-validate-not-null'}`"
                  style="width:100%;height: 100%;"
                  v-model="scope.row.useName"
                  placeholder="输入用途描述"
                  @blur="validateField('useName', scope.row)"
                />
              </template>
            </el-table-column>
            <el-table-column prop="useType" label="类型" width="145" align="center">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.useType"
                  placeholder="请选择"
                  @change="useTypeChange"
                  :class="`${scope.row.useType ? '' : 'input-validate-not-null'}`"
                >
                  <el-option label="服务器IP" value="SERVER_IP"></el-option>
                  <el-option label="BMC-IP" value="BMC_IP"> </el-option>
                  <el-option label="VIP" value="VIP"> </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="ipSubnet" label="IP网段" min-width="300" align="center">
              <template slot-scope="scope">
                <div class="wsp-display-flex">
                  <div :class="`${scope.row.useType !== 'VIP' ? 'wsp-width-45' : 'wsp-width-100'}`">
                    <el-input
                      class="wsp-width-100"
                      v-model="scope.row.ipSubnet"
                      :class="
                        `${scope.row.ipSubnet && ipv4Regex.test(scope.row.ipSubnet) ? '' : 'input-validate-not-null'}`
                      "
                    />
                  </div>
                  <div class="wsp-width-10" v-if="scope.row.useType !== 'VIP'">~</div>
                  <div class="wsp-width-45" v-if="scope.row.useType !== 'VIP'">
                    <el-input
                      class="wsp-width-100"
                      v-model="scope.row.endIp"
                      :class="`${scope.row.endIp && ipv4Regex.test(scope.row.endIp) ? '' : 'input-validate-not-null'}`"
                    />
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="netmask" label="子网掩码" width="145" align="center">
              <template slot-scope="scope">
                <el-input
                  class="wsp-width-100"
                  v-model="scope.row.netmask"
                  :class="`${scope.row.netmask && ipv4Regex.test(scope.row.netmask) ? '' : 'input-validate-not-null'}`"
                />
              </template>
            </el-table-column>
            <el-table-column prop="netgate" label="网关" width="145" align="center">
              <template slot-scope="scope">
                <el-input
                  class="wsp-width-100"
                  v-model="scope.row.netgate"
                  :class="`${scope.row.netgate && ipv4Regex.test(scope.row.netgate) ? '' : 'input-validate-not-null'}`"
                />
              </template>
            </el-table-column>
            <el-table-column prop="dns" label="DNS" min-width="220" align="center">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.dns"
                  placeholder="多个格式:0.0.0.0,0.0.0.0"
                  :class="`${scope.row.dns ? '' : 'input-validate-not-null'}`"
                  @blur="validateField('dns', scope.row)"
                />
              </template>
            </el-table-column>
            <el-table-column prop="remarks" label="备注" width="220">
              <template slot-scope="scope">
                <el-input v-model="scope.row.remarks" placeholder="备注" />
              </template>
            </el-table-column>
            <el-table-column label="操作" width="105">
              <template slot-scope="scope">
                <el-button type="text" @click="copyServerConfig(scope.row)" :disabled="scope.row.useType === 'VIP'"
                  >复制</el-button
                >
                <el-button
                  type="text"
                  @click.native.prevent="deleteServerConfig(scope.$index, serverNetworkList)"
                  size="small"
                >
                  移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>

        <div class="wsp-group-title-tip" style="margin-top: 10px;">
          <el-button type="text" @click="addServerConfig" class="el-icon-plus">新增服务器配置</el-button>
        </div>
      </div>
    </div>
    <div style=" border-top: 5.8px solid rgba(0, 0, 0,0.05);;margin: 10px 0;"></div>
    <div class="computer-room-network">
      <div class="wsp-group-title">
        <div class="wsp-group-title-icon"></div>
        <div class="wsp-group-title-value">办公区网络</div>
      </div>
      <div class="computer-room-network wsp-display-flex ">
        <div class="wsp-width-50 ">
          <h3 style="">
            本次交付云桌面<span class="bg-red font-size-18">{{ desktopIpCount }}</span
            >台，（数量同终端台数，未包含镜像使用IP），云桌面IP需要<span class="bg-3bb113 font-size-18">{{
              desktopIpCount
            }}</span
            >个
          </h3>
        </div>
        <div class="wsp-border-right wsp-margin-tb-24"></div>
        <div class="wsp-width-50 wsp-padding-lr-6">
          <h3 style="">
            本次交付终端<span class="bg-red">{{ terminalIpCount }}</span
            >台，终端IP需要<span class="bg-3bb113 font-size-18">{{ terminalIpCount }}</span
            >个
          </h3>
        </div>
      </div>
      <div class="computer-room-network">
        <el-table
          class="cal-table custom-cell-table"
          :key="serverNetWorkResourceKey"
          :data="officeNetworkList"
          stripe
          max-height="350"
          style="width: 100%;height: 250"
        >
          <el-table-column style="height: 0rem;" prop="useName" label="IP规划用途" width="135" align="center">
            <template slot-scope="scope">
              <el-input
                :class="`${scope.row.useName ? '' : 'input-validate-not-null'}`"
                style="width:100%;height: 100%;"
                v-model="scope.row.useName"
                placeholder="输入用途描述"
                @blur="validateField('useName', scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column prop="useType" label="类型" width="145" align="center">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.useType"
                placeholder="请选择"
                @change="useTypeChange"
                :class="`${scope.row.useType ? '' : 'input-validate-not-null'}`"
              >
                <el-option label="云桌面IP" value="CLOUD_DESKTOP_IP"></el-option>
                <el-option label="终端IP" value="TERMINAL_IP"> </el-option>
                <el-option label="桌面编辑镜像IP" value="DESKTOP_IMAGE_IP"> </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="ipSubnet" label="IP网段" min-width="300" align="center">
            <template slot-scope="scope">
              <!-- <el-input
                v-model="scope.row.ipSubnet"
                :class="`${scope.row.ipSubnet ? '' : 'input-validate-not-null'}`"
                placeholder="格式:0.0.0.0"
                @blur="validateField('ipSubnet', scope.row)"
              /> -->
              <div class="wsp-display-flex">
                <div class="wsp-width-45">
                  <el-input
                    class="wsp-width-100"
                    v-model="scope.row.ipSubnet"
                    :class="
                      `${scope.row.ipSubnet && ipv4Regex.test(scope.row.ipSubnet) ? '' : 'input-validate-not-null'}`
                    "
                  />
                </div>
                <div class="wsp-width-10">~</div>
                <div class="wsp-width-45">
                  <el-input
                    class="wsp-width-100"
                    @change="inputEndIpChange(scope.$index, scope.row.ipSubnet, scope.row.endIp)"
                    v-model="scope.row.endIp"
                    :class="`${scope.row.endIp && ipv4Regex.test(scope.row.endIp) ? '' : 'input-validate-not-null'}`"
                  />
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="netmask" label="子网掩码" width="145" align="center">
            <template slot-scope="scope">
              <el-input
                class="wsp-width-100"
                v-model="scope.row.netmask"
                :class="`${scope.row.endIp && ipv4Regex.test(scope.row.endIp) ? '' : 'input-validate-not-null'}`"
              />
            </template>
          </el-table-column>
          <el-table-column prop="netgate" label="网关" width="145" align="center">
            <template slot-scope="scope">
              <el-input
                class="wsp-width-100"
                v-model="scope.row.netgate"
                :class="`${scope.row.netgate && ipv4Regex.test(scope.row.netgate) ? '' : 'input-validate-not-null'}`"
              />
            </template>
          </el-table-column>
          <el-table-column prop="dns" label="DNS" min-width="220" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.dns"
                placeholder="多个格式:0.0.0.0,0.0.0.0"
                @blur="validateField('dns', scope.row)"
                :class="`${scope.row.dns ? '' : 'input-validate-not-null'}`"
              />
            </template>
          </el-table-column>
          <el-table-column prop="remarks" label="备注" width="220">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remarks" placeholder="备注" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="95" align="center">
            <template slot-scope="scope">
              <!-- <el-button type="text" @click="copyOfficeNetwork(scope.row)">复制</el-button> -->
              <el-button
                type="text"
                @click.native.prevent="deleteOfficeNetwork(scope.$index, officeNetworkList)"
                size="small"
              >
                移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="wsp-group-title-tip" style="margin-top: 10px;">
          <el-button type="text" @click="addOfficeNetwork" class="el-icon-plus">新增配置</el-button>
        </div>
      </div>
    </div>
    <div style=" border-top: 5.8px solid rgba(0, 0, 0,0.05);margin: 10px 0;"></div>
    <div class="computer-room-network">
      <div class="wsp-group-title">
        <div class="wsp-group-title-icon"></div>
        <div class="wsp-group-title-value">放行端口</div>
        <div class="wsp-group-title-tip"></div>
      </div>
      <div class="computer-room-network" style="margin-top: 10px;">
        <el-switch v-model="hasFirewall" active-text="机房与办公区网络之间有防火墙等安全设备需要开启"> </el-switch>
        <i class="el-icon-question" @click="showTipsQuestion('portOpen', '端口放行')"></i>
        <div class="wsp-display-flex wsp-width-50 wsp-text-align-right wsp-padding-tb-12" v-if="hasFirewall">
          <div>
            开放端口列表：
          </div>
          <div>
            <a href="https://ruijie.feishu.cn/sheets/PtRosyGkthpBIktzRalcEUmenOg" target="_blank">点击查看</a>
          </div>
        </div>
      </div>
    </div>

    <el-drawer
      ref="drawer"
      :visible="visableTips"
      :modal-append-to-body="false"
      :modal="false"
      :append-to-body="false"
      size="23%"
      :before-close="closerTipsDrawer"
      direction="rtl"
      style="z-index: 1000;"
    >
      <div
        style="margin-top: -70px;margin-bottom: 20px;margin-left: 10px;margin-right: 60px;"
        class="wsp-padding-tb-12"
      >
        <div>
          <div
            style="background: #0052d9;margin: 12px 0;width: 6px;height: 31px;display: inline-block; margin-bottom: -10px;"
          ></div>
          <div style="display: inline-block; margin-bottom: 5px; margin-left: 8px;  font-size: large;">
            <template>
              <span>{{ visableTitle }}</span
              ><span>说明</span>
            </template>
          </div>
        </div>
      </div>
      <div class="drawer-tips">
        <div class="tips-rl-question">相关解释</div>
        <div class="drawer-tips-content">{{ lang.t(visableExplanation) }}</div>
        <div v-if="lang.t(visableQuestion) !== ''" class="tips-rl-question">热点问题</div>
        <div v-if="lang.t(visableQuestion) !== ''" class="drawer-tips-content">{{ lang.t(visableQuestion) }}</div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { Form, Input, Button, Select, Option, Table, TableColumn, InputNumber, Drawer, Switch } from 'element-ui'

import { SkIp } from 'sk-ui'

import { getPorjectNetworkDetail, saveOrUpdateNetwork } from '@/api/deliveryNetwork'
import { getDetail } from '@/api/deliveryProject'
import lang from '@/lang'
import { getIpBetweenCont } from '@/utils/ipUtils'
export default {
  name: 'SkyStepViewNetworkInfo',
  components: {
    [Form.name]: Form,
    [Input.name]: Input,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [InputNumber.name]: InputNumber,
    [Drawer.name]: Drawer,
    [Switch.name]: Switch,
    [SkIp.name]: SkIp
  },
  props: {
    projectId: {
      type: String
    },
    industryId: {
      type: String
    }
  },
  data: function() {
    return {
      lang: lang,
      visableTitle: null,
      visableQuestin: null,
      visableTips: false,
      visableExplanation: null,
      visableQuestion: null,
      isDisabled: true,
      serverIpCount: 0,
      serverVipCount: 0,
      desktopIpCount: 0,
      ipv4Regex: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
      terminalIpCount: 0,
      serverNetWorkResourceKey: 0,
      serverNetworkList: [
        {
          useName: '服务器集群访问IP',
          useType: 'VIP',
          ipSubnet: null,
          netgate: null,
          netmask: '255.255.255.0',
          dns: null,
          num: 1
        },
        {
          useName: '服务器',
          useType: 'SERVER_IP',
          ipSubnet: null,
          netgate: null,
          netmask: '255.255.255.0',
          dns: null,
          num: 1
        },
        {
          useName: '服务器bmc',
          useType: 'BMC_IP',
          ipSubnet: null,
          netgate: null,
          netmask: '255.255.255.0',
          dns: null,
          num: 1
        }
      ],
      officeNetworkList: [
        {
          useName: '云桌面',
          useType: 'CLOUD_DESKTOP_IP',
          ipSubnet: null,
          netgate: null,
          netmask: '255.255.255.0',
          dns: null,
          num: 1
        },
        {
          useName: '终端',
          useType: 'TERMINAL_IP',
          ipSubnet: null,
          netgate: null,
          netmask: '255.255.255.0',
          dns: null,
          num: 1
        },
        {
          useName: '桌面编辑镜像',
          useType: 'DESKTOP_IMAGE_IP',
          ipSubnet: null,
          netgate: null,
          netmask: '255.255.255.0',
          dns: null,
          num: 1
        }
      ],
      networkList: [],
      projectDetail: {},
      hasFirewall: false,
      rules: {
        useName: { required: true, message: '请输入规划用途', trigger: 'blur' },
        useType: { required: true, message: '请选择类型', trigger: 'blur' },
        ipSubnet: { required: true, message: '请输入IP', trigger: 'blur' },
        netgate: { required: true, message: '请输入子网掩码', trigger: 'blur' },
        netmask: { required: true, message: '请输入网关', trigger: 'blur' },
        dns: { required: true, message: '请输入DNS', trigger: 'blur' }
      }
    }
  },
  created() {
    this.getInit()
    this.$emit('showBtns', {
      preStep: true,
      nextStep: true,
      saveStep: false,
      enableTabChange: true,
      enableSkipNext: true
    })
  },
  mounted() {},
  methods: {
    serverIpChange(index, attr) {
      // this.$set(this.serverNetworkList[0])
    },
    valdateNull(aaa) {},
    showTipsQuestion(tipLabel, title) {
      this.visableTips = true
      this.visableExplanation = 'tips.explanation.' + tipLabel
      this.visableQuestion = 'tips.question.' + tipLabel
      this.visableTitle = title
    },
    inputEndIpChange(index, startIp, endIp) {
      if (startIp && this.ipv4Regex.test(startIp) && endIp && this.ipv4Regex.test(endIp)) {
        var count = getIpBetweenCont(startIp, endIp)

        this.$set(this.officeNetworkList[index], 'num', count)
        this.useTypeChange()
      }
    },
    closerTipsDrawer() {
      this.visableTips = false
    },
    validateField(field, row) {
      const rule = this.rules[field]
      if (rule.required && !row[field]) {
        this.$store.dispatch('OpenNotification', { message: rule.message, type: 'error' })
      }
    },
    getInit() {
      getDetail({ id: this.projectId }).then(res => {
        this.projectDetail = res.data.content
      })
      getPorjectNetworkDetail({ id: this.projectId }).then(res => {
        if (res.data.content.instDeliveryNetworkDTOList.length > 0) {
          var filter_list = res.data.content.instDeliveryNetworkDTOList.filter(item => {
            return item.useType === 'SERVER_IP' || item.useType === 'BMC_IP' || item.useType === 'VIP'
          })
          filter_list.sort((a, b) => {
            if (a.useType === 'VIP' && b.useType !== 'VIP') {
              return -1 // a 在前
            }
            if (a.useType !== 'VIP' && b.useType === 'VIP') {
              return 1 // b 在前
            }
            return 0 // 相等，保持原顺序
          })

          this.serverNetworkList = filter_list
          this.officeNetworkList = res.data.content.instDeliveryNetworkDTOList.filter(item => {
            return item.useType !== 'SERVER_IP' && item.useType !== 'BMC_IP' && item.useType !== 'VIP'
          })
        }
        this.hasFirewall = res.data.content.hasFirewall
        this.useTypeChange()
      })
    },
    useTypeChange() {
      this.serverIpCount = 0
      this.serverVipCount = 0
      this.desktopIpCount = 0
      this.terminalIpCount = 0
      this.serverNetworkList.forEach(item => {
        if (item.useType === 'SERVER_IP') {
          this.serverIpCount += 1
        }
        if (item.useType === 'VIP') {
          this.serverVipCount += 1
        }
      })
      this.officeNetworkList.forEach(item => {
        if (item.useType === 'TERMINAL_IP') {
          this.terminalIpCount += item.num
        }
      })
      this.officeNetworkList.forEach(item => {
        if (item.useType === 'CLOUD_DESKTOP_IP') {
          this.desktopIpCount += item.num
        }
      })
    },
    addServerConfig() {
      var item = {
        useName: null,
        useType: null,
        ipSubnet: null,
        netgate: null,
        netmask: '255.255.255.0',
        dns: null,
        num: 1,
        remarks: null
      }
      this.serverNetworkList.push(item)
    },
    copyServerConfig(row) {
      var resultList = this.serverNetworkList.filter(item => {
        return item.useType === row.useType
      })
      if (resultList.length >= 5) {
        return
      }

      var useName
      if (row.useName) {
        useName = row.useName + ' copy'
      } else {
        useName = null
      }
      var newRow = {
        useName: useName,
        useType: row.useType,
        ipSubnet: row.ipSubnet,
        netgate: row.netgate,
        netmask: row.netmask,
        dns: row.dns,
        num: row.num
      }
      this.serverNetworkList.push(newRow)

      this.useTypeChange()
    },
    deleteServerConfig(index, rows) {
      rows.splice(index, 1)
      this.useTypeChange()
    },
    addOfficeNetwork() {
      var item = {
        useName: null,
        useType: null,
        ipSubnet: null,
        netgate: null,
        netmask: '255.255.255.0',
        dns: null,
        num: 1,
        remarks: null
      }
      this.officeNetworkList.push(item)
    },
    copyOfficeNetwork(row) {
      var useName
      if (row.useName) {
        useName = row.useName + ' copy'
      } else {
        useName = null
      }
      var newRow = {
        useName: useName,
        useType: row.useType,
        ipSubnet: row.ipSubnet,
        netgate: row.netgate,
        netmask: row.netmask,
        dns: row.dns,
        num: row.num
      }
      this.officeNetworkList.push(newRow)
      this.useTypeChange()
    },
    deleteOfficeNetwork(index, rows) {
      rows.splice(index, 1)
      this.useTypeChange()
    },
    async gotoNextStep() {
      this.message = '点击了下一步'

      var serverList = this.serverNetworkList.filter(item => {
        return item.useType === 'SERVER_IP'
      })
      if (serverList.length >= 5) {
        this.$store.dispatch('OpenNotification', { message: '服务器IP暂时最多只能设置5个', type: 'error' })
        return false
      }

      var bmcList = this.serverNetworkList.filter(item => {
        return item.useType === 'BMC_IP'
      })
      if (bmcList.length >= 5) {
        this.$store.dispatch('OpenNotification', { message: 'BMC_IP暂时最多只能设置5个', type: 'error' })
        return false
      }

      const validateFields = element => {
        if (!element.useName) {
          this.$store.dispatch('OpenNotification', { message: 'ip规划用途不能为空', type: 'error' })
          return false
        }
        if (!element.useType) {
          this.$store.dispatch('OpenNotification', { message: '类型不能为空', type: 'error' })
          return false
        }
        if (!element.ipSubnet) {
          this.$store.dispatch('OpenNotification', { message: 'ip不能为空', type: 'error' })
          return false
        }
        if (!element.netmask) {
          this.$store.dispatch('OpenNotification', { message: '子网掩码不能为空', type: 'error' })
          return false
        }
        if (!element.netgate) {
          this.$store.dispatch('OpenNotification', { message: '网关不能为空', type: 'error' })
          return false
        }
        if (!element.dns) {
          this.$store.dispatch('OpenNotification', { message: 'dns不能为空', type: 'error' })
          return false
        }
        return true
      }

      const newNetworkList = []

      for (const element of this.serverNetworkList) {
        if (!validateFields(element)) return false
        newNetworkList.push(element)
      }

      for (const element of this.officeNetworkList) {
        if (!validateFields(element)) return false
        newNetworkList.push(element)
      }

      var result = false
      await saveOrUpdateNetwork({
        instDeliveryNetworkDTOList: newNetworkList,
        projectId: this.projectId,
        hasFirewall: this.hasFirewall
      })
        .then(res => {
          result = true
        })
        .catch(e => {
          result = false
        })
      return result
    },
    async gotoNextPreVliate() {
      var result = true
      for (const serverNetwrok of this.serverNetworkList) {
        if (
          !serverNetwrok.ipSubnet ||
          !serverNetwrok.useType ||
          !serverNetwrok.useName ||
          !serverNetwrok.netgate ||
          !serverNetwrok.dns ||
          !serverNetwrok.netmask
        ) {
          result = false
          break
        }
      }
      if (!result) {
        this.$store.dispatch('OpenNotification', { message: '还有必填项未填写，请检查！', type: 'error' })
        return result
      }

      for (const serverNetwrok of this.officeNetworkList) {
        if (
          !serverNetwrok.ipSubnet ||
          !serverNetwrok.useType ||
          !serverNetwrok.useName ||
          !serverNetwrok.netgate ||
          !serverNetwrok.endIp ||
          !serverNetwrok.dns ||
          !serverNetwrok.netmask
        ) {
          result = false
          break
        }
      }

      if (!result) {
        this.$store.dispatch('OpenNotification', { message: '还有必填项未填写，请检查！', type: 'error' })
      }

      return result
    },
    gotoPreStep() {
      this.message = '点击了上一步'
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(deploy-step-view-netwrok-info) {
  width: 100%;
  height: 80vh;
  overflow-y: auto;
  .custom-cell-table {
    .el-table__row td {
      padding: 0 !important;
    }
    .el-table__row .cell {
      height: 100%;
      padding: 0 !important;
    }
  }
}
</style>
